// Labels needed by the shared MFA setup UI. Kept separate (not re-exported
// from the apps) so this package has
// no dependency on either consuming app's source tree.
export const CANCEL = 'Cancel'
export const FINISH = 'Finish'
export const NEXT = 'Next'
export const GENERIC_SERVER_ERROR =
  'Could not execute request. Please try again later'

export const MFA_TOTP_NAME = 'Authenticator App'
export const MFA_WEB_AUTHN_NAME = 'Security Key'
export const MFA_SELECTOR_TOTP_DESCRIPTION = 'Setup the authenticator app'
export const MFA_SELECTOR_WEB_AUTHN_DESCRIPTION =
  'Setup a security key to login'

export const SETUP_MFA_SELECTOR_TITLE = 'Setup'
export const SETUP_MFA_SELECTOR_MESSAGE =
  'Choose one of the authentication methods below'
export const SETUP_MFA_SELECTOR_FOOTNOTE =
  'Learn more about two-factor authentication'
export const SETUP_ALL_MFA_ALREADY_REGISTERED_ERROR =
  'All MFA methods have already been configured'
export const SETUP_MFA_ALREADY_REGISTERED_ERROR =
  'MFA method has already been configured'
export const SETUP_MFA_GENERIC_ERROR =
  'Failed to register, please try again. If the error persists contact support'

export const SETUP_MFA_TOTP_TITLE = 'Setup authenticator app'
export const SETUP_MFA_TOTP_MESSAGE_START_REGISTRATION_STEP =
  "If you don't have an authenticator app, please download and install it before proceeding to the next step"
export const SETUP_MFA_TOTP_MESSAGE_REGISTER_STEP =
  'Scan the QR code with the authenticator app and enter the 6-digit code below'
export const SETUP_MFA_TOTP_FOOTNOTE = 'Learn more about the authenticator app'
export const SETUP_MFA_TOTP_VERIFICATION_CODE = 'Verification code'
export const SETUP_MFA_TOTP_VERIFICATION_CODE_PLACEHOLDER =
  'Enter the 6-digit code'
export const SETUP_TOTP_INVALID_OTP = 'Invalid verification code'
export const AUTHENTICATOR_APP_DOWNLOAD =
  'We suggest using Google Authenticator:'

export const SETUP_MFA_WEB_AUTHN_TITLE = 'Setup security key'
export const SETUP_MFA_WEB_AUTHN_MESSAGE_START_REGISTRATION_STEP =
  'Make sure you have a compatible security key'
export const SETUP_MFA_WEB_AUTHN_MESSAGE_REGISTER_STEP =
  'Insert your security key. If it has a button, tap it'
export const SETUP_MFA_WEB_AUTHN_FOOTNOTE = 'Learn more about security keys'
export const SETUP_MFA_WEB_AUTHN_LOCAL_LOGIN_REQUIRED_ERROR =
  'Local login is required'
export const SETUP_MFA_WEB_AUTHN_RECOVERY_OTP_REQUIRED_ERROR = '2FA not enabled'
export const SETUP_MFA_WEB_AUTHN_INVALID_REGISTRATION_ERROR =
  'Invalid registration, please try again. If the error persists contact support'

export const RECOVERY_OTP_PRINT_TITLE = 'Recovery Codes'
export const RECOVERY_OTP_DOWNLOAD_BUTTON = 'Download'
export const RECOVERY_OTP_PRINT_BUTTON = 'Print'
export const RECOVERY_OTP_COPY_BUTTON = 'Copy'

export const RECOVERY_OTP_CONFIG_TITLE = 'Recovery codes'
export const RECOVERY_OTP_CONFIG_MESSAGE =
  'Please save the following recovery codes. These codes will help you login if you lose access to your configured authentication methods'
export const RECOVERY_OTP_CONFIG_BUTTON = 'Continue'

export const RECOVERY_OTP_CONFIRM_TITLE = 'Make sure you saved the codes'
export const RECOVERY_OTP_CONFIRM_MESSAGE =
  "You won't be able to access these codes again, make sure you saved them before proceeding"
export const RECOVERY_OTP_CONFIRM_CANCEL = 'Back'
export const RECOVERY_OTP_CONFIRM_CONTINUE = "Yes, I've saved them"

export const REVOKE_MFA_VALIDATE_PASSWORD_ERROR =
  'Could not validate your password'
export const RECOVERY_OTP_TEXT_FILE_TITLE = 'Recovery Codes:\n\n'
export const RECOVERY_OTP_TEXT_FILE_NAME = 'recovery-codes.txt'
